import { SelectChangeEvent } from '@mui/material';
import { getHeader, gradeMap, defaultOption } from '~/utils/constants';
import { dropdown } from './FileSearch.style';
import { useSelector } from 'react-redux';
import { RootState, useAppDispatch } from '~/store';
import { setSearchCondition } from '~/store/file';
import { useMemo } from 'react';
import { TSearchCondition } from '~/store/resource/resource.type';
import { resourceEduCode } from '~/api/oneBoxV3/oneBoxV3.type';
const subjectType = {
  國小: ['國語', '數學', '生活', '自然', '社會', '健體', '綜合', '藝文'],
  國中: [
    '國文',
    '英語',
    '數學',
    '自然',
    '地理',
    '歷史',
    '公民',
    '科技',
    '健體',
    '綜合',
  ],
  高中: [
    '國文',
    '數學',
    '生物',
    '物理',
    '化學',
    '地球科學',
    '地理',
    '歷史',
    '公民與社會',
  ],
};

const setEduCodeOption = (eduCode: string) => {
  switch (eduCode) {
    case resourceEduCode.E:
      return ['1', '2', '3', '4', '5', '6'];
    case resourceEduCode.J:
      return ['1', '2', '3'];
    case resourceEduCode.H:
      return [
        '全',
        '全冊次',
        '第一冊',
        '第三冊',
        '第三冊A',
        '第三冊B',
        '第二冊',
        '第五冊',
        '第四冊',
        '第四冊A',
        '第四冊B',
        '選修I',
        '選修II',
        '選修III',
        '選修IV',
        '選修V',
        '選修乙上',
        '選修乙上乙版',
        '選修乙下',
        '選修甲上',
        '選修甲上乙版',
        '選修甲下',
      ];
    default:
      break;
  }
};
export const FileSearch = () => {
  const { eduCodes, years, grades, subjects } = useSelector(
    (state: RootState) => state.file.searchCondition,
  );

  const dispatch = useAppDispatch();

  const filters = useMemo(
    () => [
      {
        id: 'eduCodes',
        search: eduCodes,
        options: defaultOption.eduCodes,
      },
      {
        id: 'subjects',
        search: subjects,
        options: subjectType[eduCodes === null ? '國小' : eduCodes],
      },
      {
        id: 'years',
        search: years,
        options: ['115', '114', '113', '112', '111', '110', '109'],
      },
      {
        id: 'grades',
        search: grades,
        options: setEduCodeOption(eduCodes || ''),
      },
    ],
    [eduCodes, years, grades, subjects],
  );

  return (
    <dropdown.Container>
      {filters.map(({ id, search, options }) => {
        return (
          <dropdown.FormControl key={id}>
            <dropdown.Label>
              {getHeader(id as keyof TSearchCondition)}
            </dropdown.Label>
            <dropdown.Select
              value={search}
              label={getHeader(id as keyof TSearchCondition)}
              name={id}
              onChange={(event: SelectChangeEvent<unknown>) => {
                const { name, value } = event.target;
                dispatch(setSearchCondition({ [`${name}`]: value as string }));
              }}
              MenuProps={{
                PaperProps: {
                  style: { maxHeight: '50vh' },
                },
              }}
            >
              {options?.map(option => (
                <dropdown.Item value={option} key={option}>
                  {id === 'grade' ? gradeMap(`${option}`) : option}
                </dropdown.Item>
              ))}
            </dropdown.Select>
          </dropdown.FormControl>
        );
      })}
    </dropdown.Container>
  );
};
